<template>
  <div class="fixed-bottom footer">
    <p class="text-center">©2018 <a href="http://www.funkybits.fr">FunkyBits</a></p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
  .footer {
    opacity: 0.7;
    z-index: -1;

    font-size: 12px;
    color: $footer-color;

    a {
      color: $footer-color;

      &:hover,
      &:focus {
        color: lighten($footer-color, 20%);
        text-decoration: none;
      }
    }

    p {
      margin-bottom: 0.7rem;
    }

  }
</style>
